import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AcquisitionTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-acquisitiontype',
  templateUrl: './acquisitiontype.component.html',
  styleUrls: ['./acquisitiontype.component.scss']
})
export class AcquisitiontypeComponent implements OnChanges {

  acquisitiontypeForm: FormGroup;
  acquisitiontypeFormArray: FormGroup;
  control = new FormControl();
  @Input() acquisitiontypes: AcquisitionTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() acquisitiontype = new EventEmitter<AcquisitionTypeDto[]>();
  @Output() deleteAcquisitionTypeEvent = new EventEmitter<any>();

  selectedAcquisitionType: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createAcquisitionTypeForm();
  }

  createAcquisitionTypeForm() {
    this.acquisitiontypeForm = this.fb.group({
      AcquisitionTypeName: ['', Validators.required],
      id: null,
    });
    this.acquisitiontypeFormArray = this.fb.group({
      AcquisitionTypes: this.fb.array([]),
    });
    this.setAcquisitionType();
  }

  // method to display acquisitiontypes
  setAcquisitionType() {
    const control = this.acquisitiontypeFormArray.controls.AcquisitionTypes as FormArray;
    this.acquisitiontypes.forEach((e) => {
      control.push(
        this.fb.group({
          AcquisitionTypeName: e.AcquisitionTypeName,
          id: e.id,
        })
      );
    });
  }

  // method to add AcquisitionType
  addAcquisitionType(value: AcquisitionTypeDto) {
    const control = this.acquisitiontypeFormArray.controls.AcquisitionTypes as FormArray;
    control.insert(
      0,
      this.fb.group({
        AcquisitionTypeName: value.AcquisitionTypeName,
        id: null,
      })
    );
  }

  selectAcquisitionType(value) {}

  // method to delete acquisitiontype from arrary list
  deleteAcquisitionType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.acquisitiontypeFormArray.controls.AcquisitionTypes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.acquisitiontypes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.acquisitiontypes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: AcquisitionTypeDto) {
    if (this.acquisitiontypeForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.acquisitiontypeFormArray
        .get('AcquisitionTypes')
        ['controls'][this.selectedIndex].patchValue({
          AcquisitionTypeName: formValue.AcquisitionTypeName,
        });
    } else {
      this.addAcquisitionType(formValue);
    }
    this.selectedIndex = null;
    this.acquisitiontypeForm.reset();
  }

  onEdit(index, value: AcquisitionTypeDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.acquisitiontypeForm.patchValue({ AcquisitionTypeName: value.AcquisitionTypeName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.acquisitiontypeForm.reset();
  }

  onSubmit(formValue: AcquisitionTypeDto[]) {
    this.acquisitiontype.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteAcquisitionTypeEvent.emit(this.filteredDelete);
    }
  }
}
